/**
 * 편집기를 처음 열 때 어느 재무제표 유형을 보여줄지 정하는 규칙.
 *
 * effect 안에 두면 "세 우선순위 중 무엇이 이겼는지"를 화면을 띄워야만 알 수 있어
 * 순수 함수로 분리했다 — effect 는 결과를 적용하기만 한다.
 */

import type { FsType } from "@/apis/ixd-editor/types";

export const resolveInitialFsType = ({
  urlFsType,
  workbookIdByFsType,
  availableFsTypes,
  current,
}: {
  /** URL 에 적혀 있던 유형. 문서에 없는 유형이면(옛 링크) 무시한다 */
  urlFsType: FsType | null;
  /** 복원된 워크북 — 비교하던 유형을 그대로 되살린다 */
  workbookIdByFsType: Partial<Record<FsType, string>>;
  /** 이 문서가 실제로 담은 유형 */
  availableFsTypes: FsType[];
  /** 지금 선택된 유형(스토어 기본값은 연결) */
  current: FsType;
}): FsType => {
  if (urlFsType && availableFsTypes.includes(urlFsType)) return urlFsType;
  if (workbookIdByFsType[current]) return current;

  const [restoredFsType] = Object.keys(workbookIdByFsType) as FsType[];
  if (restoredFsType) return restoredFsType;

  // 문서가 한쪽만 담고 있으면 그쪽으로 — 기본값(연결)에 머물면 별도만 있는 IXD 가
  // 빈 본문으로 열린다.
  const [firstAvailable] = availableFsTypes;
  if (firstAvailable && !availableFsTypes.includes(current)) return firstAvailable;

  return current;
};
